<template>
    <template-app :sidebar_data="groups()" :title="$tr('Облачное хранилище')" logo="/img/logo.svg" :settings="settings">
        <template #appbar>
            <div v-if="license" class="license">
                <div>Временная лицензия до 31.12.2026 г.</div>
            </div>
            <template v-if="authorized">
                <folder-view v-if="folder != undefined" :root="task" :folder="folder" />
                <folder-view v-else-if="trash != undefined" :trash="trash" />
                <clients-view v-else-if="admin == 'clients'" />
                <monitoring-view v-else-if="admin == 'monitoring'"></monitoring-view>
                <admin-view v-else-if="admin != undefined" :task="admin" />
            </template>
            <splash-view v-else></splash-view>
        </template>
    </template-app>
</template>

<script>
import TemplateApp from '@topomatic/tap/src/components/TemplateApp.vue';
import Dialog, { MessageBox } from '@topomatic/tap/src/dialog';
import DialogInput from '@topomatic/tap/src/components/DialogInput.vue';

import FolderView from './FolderView.vue';
import UsageView from './UsageView.vue';
import AdminView from './AdminView.vue';
import ClientsView from './ClientsView.vue';
import SplashView from './SplashView.vue';

import AppConsts from '../consts';
import MonitoringView from './MonitoringView.vue';
import SettingsView from './SettingsView.vue';
import WebDAV from './WebDAV.vue';

export default {
    name: 'FilesView',
    components: {
        TemplateApp,
        FolderView,
        AdminView,
        ClientsView,
        SplashView,
        MonitoringView,
    },
    data() {
        return {
            drives: null,
            license: process.env.VUE_APP_LICENSED === '1',
        };
    },
    created() {
        if (this.authorized) {
            this.$api.getDrives()
                .then((drives) => {
                    this.drives = drives;
                });
        }
    },
    watch: {
        authorized() {
            if (this.authorized) {
                this.$api.getDrives()
                    .then((drives) => {
                        this.drives = drives;
                    });
            } else {
                this.drives = [];
            }
        },
    },
    computed: {
        authorized() {
            return this.$api.authorized;
        },
        folder() {
            const { payload } = this.$router;
            return payload.folder || payload.drive;
        },
        trash() {
            const { payload } = this.$router;
            return payload.trash;
        },
        admin() {
            const { payload } = this.$router;
            return payload.admin;
        },
        group() {
            const { payload } = this.$router;
            const admin = payload[AppConsts.APP_GROUP_ADMINISTRATOR];
            if (admin != undefined) {
                return AppConsts.APP_GROUP_ADMINISTRATOR;
            }
            const trash = payload[AppConsts.APP_TASK_TRASH];
            if (trash != undefined) {
                return trash;
            }
            const { drive } = payload;
            if (drive != undefined) {
                const { drives } = this;
                let { me } = this.$api;
                if ((drives != undefined) && (me != undefined)) {
                    me = me.user;
                    const { companies } = me;
                    for (let i = 0; i < drives.length; i++) {
                        const cdrive = drives[i];
                        if (cdrive.id == drive) {
                            if (cdrive.user == me.id) {
                                return AppConsts.APP_GROUP_MY;
                            }
                            if (companies != undefined) {
                                for (let j = 0; j < companies.length; j++) {
                                    const company = companies[j];
                                    if (company.id == cdrive.company) {
                                        return cdrive.company;
                                    }
                                }
                            }
                            return AppConsts.APP_GROUP_SHARED;
                        }
                    }
                }
            }

            return undefined;
        },
        task() {
            const { payload } = this.$router;
            const admin = payload[AppConsts.APP_GROUP_ADMINISTRATOR];
            if (admin != undefined) {
                return admin;
            }
            const trash = payload[AppConsts.APP_TASK_TRASH];
            if (trash != undefined) {
                return AppConsts.APP_TASK_TRASH;
            }
            const { drive } = payload;
            if (drive != undefined) {
                return drive;
            }

            return undefined;
        },
    },
    methods: {
        groups() {
            if (!this.authorized) {
                return undefined;
            }
            const g = [];
            let { me } = this.$api;
            if (me == undefined) {
                return g;
            }
            me = me.user;
            const admin = me.admin;
            if (admin) {
                g.push({
                    id: AppConsts.APP_GROUP_ADMINISTRATOR,
                    title: this.$tr('Администрирование'),
                    items: [{
                        id: AppConsts.APP_TASK_COMPANIES,
                        title: this.$tr('Организации'),
                        icon: 'domain',
                    },
                    {
                        id: AppConsts.APP_TASK_USERS,
                        title: this.$tr('Пользователи'),
                        icon: 'account-multiple',
                    },
                    {
                        id: AppConsts.APP_TASK_CLIENTS,
                        title: this.$tr('Онлайн'),
                        icon: 'connection',
                    },
                    {
                        id: AppConsts.APP_TASK_MONITORING,
                        title: this.$tr('Мониторинг'),
                        icon: 'monitor',
                    },
                    ],
                });
            }
            const { drives } = this;
            if (drives == undefined) {
                return g;
            }
            const my = [];
            const shared = [];
            const companies = {};
            if (me.companies != undefined) {
                for (let i = 0; i < me.companies.length; i++) {
                    const company = me.companies[i];
                    companies[company.id] = {
                        company,
                        drives: {},
                    };
                }
            }
            for (let i = 0; i < drives.length; i++) {
                const drive = drives[i];
                if (drive.user == me.id) {
                    my[drive.id] = drive;
                } else if (drive.company != undefined) {
                    let found = false;
                    if (me.companies != undefined) {
                        for (let j = 0; j < me.companies.length; j++) {
                            if (me.companies[j].id == drive.company) {
                                found = true;
                                const edrive = companies[drive.company];
                                if (edrive != undefined) {
                                    edrive.drives[drive.id] = drive;
                                }
                                break;
                            }
                        }
                    }
                    if (!found) {
                        shared[drive.id] = drive;
                    }
                } else {
                    shared[drive.id] = drive;
                }
            }
            let items = [];
            let keys = Object.keys(my);
            for (let i = 0; i < keys.length; i++) {
                const drive = my[keys[i]];
                items.push({
                    id: keys[i],
                    title: drive.name,
                    icon: 'database',
                    actions: [{
                        title: this.$tr('WebDAV'),
                        icon: 'share-all',
                        onclick: this.webdavDrive,
                        drive,
                    },
                    {
                        title: this.$tr('Переименовать'),
                        icon: 'pencil',
                        onclick: this.renameDrive,
                        drive,
                    },
                    {
                        title: this.$tr('Удалить'),
                        icon: 'delete-forever',
                        onclick: this.deleteDrive,
                        drive,
                        drives,
                    },
                    ],
                });
            }
            items.push({
                id: AppConsts.APP_TASK_TRASH,
                title: this.$tr('Корзина'),
                icon: 'delete',
            });
            g.push({
                id: AppConsts.APP_GROUP_MY,
                title: this.$tr('Мои хранилища'),
                items,
                footer: UsageView,
                actions: [{
                    title: this.$tr('Новое хранилище'),
                    icon: 'plus-circle',
                    onclick: this.addDrive,
                }],
            });
            const companies_keys = Object.keys(companies);
            for (let i = 0; i < companies_keys.length; i++) {
                const item = companies[companies_keys[i]];
                items = [];
                keys = Object.keys(item.drives);
                for (let j = 0; j < keys.length; j++) {
                    const drive = item.drives[keys[j]];
                    let actions = null;
                    if (item.company.isadmin) {
                        actions = [{
                            title: this.$tr('WebDAV'),
                            icon: 'share-all',
                            onclick: this.webdavDrive,
                            drive,
                        }, {
                            title: this.$tr('Переименовать'),
                            icon: 'pencil',
                            onclick: this.renameDrive,
                            drive,
                        },
                        {
                            title: this.$tr('Удалить'),
                            icon: 'delete-forever',
                            onclick: this.deleteDrive,
                            drive,
                            drives,
                        },
                        ];
                    }
                    items.push({
                        id: keys[j],
                        title: drive.name,
                        icon: 'database',
                        actions,
                    });
                }
                if (item.company.isadmin) {
                    items.push({
                        id: AppConsts.APP_TASK_TRASH,
                        title: this.$tr('Корзина'),
                        icon: 'delete',
                    });
                }
                if (items.length > 0) {
                    const group = {
                        id: item.company.id,
                        title: item.company.name,
                        items,
                    };
                    if (item.company.isadmin) {
                        group.actions = [{
                            title: this.$tr('Новое хранилище'),
                            icon: 'plus-circle',
                            onclick: this.addDrive,
                        }];
                        group.footer = UsageView;
                    }
                    g.push(group);
                }
            }
            items = [];
            keys = Object.keys(shared);
            for (let i = 0; i < keys.length; i++) {
                const drive = shared[keys[i]];
                items.push({
                    id: keys[i],
                    title: drive.name,
                    icon: 'database',
                    actions: [{
                        title: this.$tr('WebDAV'),
                        icon: 'share-all',
                        onclick: this.webdavDrive,
                        drive,
                    }, {
                        title: this.$tr('Отказаться'),
                        icon: 'delete-sweep',
                        onclick: this.revokeDrive,
                        drive,
                    }],
                });
            }
            g.push({
                id: AppConsts.APP_GROUP_SHARED,
                title: this.$tr('Доступные хранилища'),
                items,
            });

            const sgroup = this.group;
            const stask = this.task;
            let initialized = false;
            for (let i = 0; i < g.length; i++) {
                const group = g[i];
                items = group.items;
                for (let j = 0; j < items.length; j++) {
                    items[j].group = group.id;
                    items[j].route = this.itemPayload(items[j]);
                    items[j].active = false;
                    if ((!initialized) && (group.id == sgroup) && (items[j].id == stask)) {
                        items[j].active = true;
                        initialized = true;
                    }
                }
            }
            if (!initialized) {
                for (let i = 0; i < g.length; i++) {
                    const group = g[i];
                    items = group.items;
                    if (items.length > 0) {
                        items[0].active = true;
                        const { route } = items[0];
                        this.$nextTick(() => {
                            this.navigate(route);
                        });
                        initialized = true;
                        break;
                    }
                    if (initialized) {
                        break;
                    }
                }
            }
            return g;
        },
        navigate(payload) {
            this.$router.push(payload);
        },
        driveExists(company, name) {
            const { drives } = this;
            for (let i = 0; i < drives.length; i++) {
                const drive = drives[i];
                if (drive.company == company) {
                    if (drive.name == name) {
                        return true;
                    }
                }
            }
            return false;
        },
        addDrive(context) {
            const payload = {
                title: this.$tr('Новое хранилище'),
                ok: this.$tr('Создать'),
                placeholder: this.$tr('Название хранилища'),
                value: '',
                focus: true,
                validate: (value) => (value || '').trim().length > 0,
            };
            Dialog(DialogInput, payload)
                .then(() => {
                    let company = context.id;
                    if (company == AppConsts.APP_GROUP_MY) {
                        company = undefined;
                    }
                    if (!this.driveExists(company, payload.value)) {
                        this.$api.addDrive(payload.value, company)
                            .then((drive) => {
                                this.drives.push(drive.file);
                            });
                    }
                });
        },
        renameDrive(context) {
            const payload = {
                title: this.$tr('Переименовать'),
                ok: this.$tr('Переименовать'),
                placeholder: this.$tr('Название хранилища'),
                value: context.drive.name,
                focus: true,
                validate: (value) => (value || '').trim().length > 0,
            };
            Dialog(DialogInput, payload)
                .then(() => {
                    if (!this.driveExists(context.drive.company, payload.value)) {
                        this.$api.renameFile(context.drive.id, payload.value)
                            .then((drive) => {
                                context.drive.name = drive.file.name;
                            });
                    }
                });
        },
        deleteDrive(context) {
            const msg = this.$tr('Вы действительно хотите удалить хранилище "{0}"?').replace('{0}', context.drive.name);
            const payload = {
                ok: this.$tr('Удалить'),
                destructive: true,
            };
            MessageBox(this.$tr('Удалить'), msg, payload)
                .then(() => {
                    this.$api.removeFile(context.drive.id)
                        .then(() => {
                            const index = context.drives.indexOf(context.drive);
                            if (index >= 0) {
                                context.drives.splice(index, 1);
                            }
                        });
                });
        },
        revokeDrive(context) {
            const msg = this.$tr('Вы действительно хотите отказаться от доступа к "{0}"?').replace('{0}', context.drive.name);
            const payload = {
                ok: this.$tr('Отказаться'),
                destructive: true,
            };
            MessageBox(this.$tr('Отказаться'), msg, payload)
                .then(() => {
                    this.$api.revokeDrive(context.drive.id)
                        .then(() => {
                            const index = context.drives.indexOf(context.drive);
                            if (index >= 0) {
                                context.drives.splice(index, 1);
                            }
                        });
                });
        },
        webdavDrive(context) {
            const uri = new URL(document.location.origin);
            const payload = {
                title: 'WebDAV',
                value: `${uri.origin}/webdav/${context.drive.id}`,
                cancel: '',
            };
            Dialog(WebDAV, payload)
                .then();
        },
        itemPayload(item) {
            const { group } = item;
            const { id } = item;
            if (group == AppConsts.APP_GROUP_ADMINISTRATOR) {
                const payload = {};
                payload[AppConsts.APP_GROUP_ADMINISTRATOR] = id;
                return payload;
            }
            if (id == AppConsts.APP_TASK_TRASH) {
                return {
                    trash: group,
                };
            }
            return {
                drive: id,
            };
        },
        settings() {
            this.$api.getSettings().then((settings) => {
                const payload = {
                    $api: this.$api,
                    cancel: '',
                    ...settings,
                };
                Dialog(SettingsView, payload).then();
            });
        },
    },
    mounted() {
        this.drive = (msg) => {
            if (msg.action == 'create') {
                if (this.authorized) {
                    this.$api.getDrives()
                        .then((drives) => {
                            this.drives = drives;
                        });
                }
            }
        };
        this.$api.wsRegister('drive', this.drive);
    },
    unmounted() {
        this.$api.wsUnregister('drive', this.drive);
    },
};
</script>

<style scoped>
.license {
    position: fixed;
    z-index: 10000;
    user-select: none;
    top: 64px;
    margin: auto;
    width: 100%;
}

.license div {
    background: #ff1744;
    color: white;
    width: fit-content;
    margin: auto;
    padding: 2px 8px 2px 8px;
    border-radius: 0px 0px 8px 8px;
}
</style>
